<template>
  <div class="patientDetail">
    <PatientDetail backRoute="DoctorPatientsList" @viewPatientFiles="viewPatientFiles" />
    <PatientTreatmentList treatmentHistoryDetailRoute="DoctorPatientTreatmentDetail" />
  </div>
</template>

<script>
import PatientDetail from '@/views/components/patients/Detail2';
import PatientTreatmentList from '@/views/components/patients/PatientTreatmentList2';

export default {
  components: {
    PatientDetail,
    PatientTreatmentList,
  },
  methods: {
    viewPatientFiles(id) {
      this.$router.push({
        name: 'DoctorPatientFiles',
        params: { patientId: id },
      });
    },
  },
};
</script>
